import React, { useState } from 'react';
import Modal from '@Shared.Angular/flowingly.components/Modal/Modal';

type props = {
  title: string;
  subject: string;
  closeModal: () => void;
  deleteAction: () => void;
  confirmationWord?: string;
  children?: React.ReactNode;
  id?: string;
};

function DeleteModal(props: props) {
  const {
    title,
    subject,
    closeModal,
    deleteAction,
    confirmationWord = 'delete',
    children,
    id
  } = props;

  const [deleteText, setDeleteText] = useState('');

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDeleteText(event.target.value);
  };

  const isDeleteDisabled = () => {
    return !(
      deleteText.toLowerCase().trim() === confirmationWord.toLowerCase()
    );
  };

  return (
    <Modal
      id={id}
      title={title}
      onClose={closeModal}
      actionButtonText="Delete"
      actionButtonType="danger"
      onCancelClick={closeModal}
      onActionClick={deleteAction}
      isActionDisabled={!deleteAction || isDeleteDisabled()}
    >
      <div className="delete-modal">
        <fieldset className="delete-modal-fieldset">
          <legend className="delete-modal-legend">
            <b>Warning</b>
          </legend>
          {deleteAction && (
            <>
              <div>
                You are about to delete <b>{subject}</b>.
              </div>
              <div>This cannot be undone!</div>
              <br />
            </>
          )}
          {children}
          {deleteAction && (
            <>
              <div>
                Type <b>{confirmationWord.toUpperCase()}</b> to continue
              </div>
              <input
                type="text"
                id="delete-modal"
                className="delete-modal-textfield"
                value={deleteText}
                onChange={handleInputChange}
              />
            </>
          )}
        </fieldset>
      </div>
    </Modal>
  );
}

export default DeleteModal;
